import { formatINR } from '../../shared/data/common';

/** Server product types, in the order the admin pages list them. */
export const productTypes = [['Flight', 'Flights'], ['Hotel', 'Hotels'], ['Bus', 'Bus'], ['Transfer', 'Cabs'], ['Insurance', 'Insurance']];
export const productLabel = Object.fromEntries(productTypes);

export const bookingStatuses = ['Confirmed', 'Pending', 'OnHold', 'Cancelled', 'PartiallyCancelled', 'CancellationPending', 'Failed'];

const statusText = { OnHold: 'On hold', PartiallyCancelled: 'Partly cancelled', CancellationPending: 'Cancelling', AwaitingCustomer: 'Awaiting customer', InProgress: 'In progress' };
export const describeStatus = (status) => statusText[status] || status;

/** Pill style for a booking or amendment status, reusing the site's status-pill colours. */
export function statusClass(status) {
  if (['Confirmed', 'Completed'].includes(status)) return 'status-pill live';
  if (/Cancel|Failed|Rejected/.test(status)) return 'status-pill cancelled';
  return 'status-pill';
}

/** Whole rupees with a minus sign for losses and refunds. */
export const money = (amount) => (amount < 0 ? `−${formatINR(-amount)}` : formatINR(amount || 0));

/** Profit as a share of sales, e.g. "4.2%". */
export const margin = (profit, sale) => (sale > 0 ? `${((profit / sale) * 100).toFixed(1)}%` : '—');

export const fmtDateTime = (iso) => new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
export const fmtDay = (isoDate) => (isoDate
  ? new Date(`${isoDate}T00:00:00`).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
  : '—');

/** "YYYY-MM-DD" for a date n days before today (local time). */
export function daysAgoIso(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** KPI tiles shared by the bookings and reports pages. */
export function ProfitTiles({ totals }) {
  const tiles = [
    ['Bookings', totals.bookings.toLocaleString('en-IN'), totals.cancelled ? `${totals.cancelled} cancelled` : 'none cancelled'],
    ['Sales', money(totals.saleAmount), 'paid by customers'],
    ['Supplier cost', money(totals.supplierAmount), 'paid to suppliers'],
    ['Markup', money(totals.markup), 'convenience fees kept'],
    ['Discounts', money(totals.discounts), 'promo codes given'],
    ['Refunds', money(totals.customerRefunds - totals.supplierRefunds), `${money(totals.customerRefunds)} out, ${money(totals.supplierRefunds)} back`],
    ['Profit', money(totals.profit), `${margin(totals.profit, totals.saleAmount)} margin`],
  ];
  return (
    <div className="admin-kpis">
      {tiles.map(([label, value, note]) => (
        <div key={label} className={`admin-kpi${label === 'Profit' ? (totals.profit < 0 ? ' loss' : ' gain') : ''}`}>
          <span className="muted small">{label}</span>
          <b>{value}</b>
          <span className="muted small">{note}</span>
        </div>
      ))}
    </div>
  );
}
